namespace $.$$ {

	$mol_style_define( $eve_pagination, {
		display: 'inline-flex',
		alignItems: 'center',
	} )

}
